import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SiteConfigService } from '../../core/services/core.site-config.service';
import { UiService } from '../../core/services/core.ui.service';

import * as _ from 'lodash';

@Injectable()
export class GfMeetingService {

    private siteConfig: any = null;
    private providerConfig: any = null;


    constructor(
        private window: Window,
        private httpClient: HttpClient,
        private siteConfigService: SiteConfigService,
        private uiService: UiService) {

        this.siteConfig = this.siteConfigService.getSiteConfig();

        this.providerConfig = {
            zoom: {
                title: 'Zoom',
                key: 'zoom',
                logo: '/core/img/3rdpartysignin/zoom-camera-2.png',
                tokenName: 'code',
                urlTemplate: 'https://zoom.us/oauth/authorize?response_type=code&client_id=${clientId}&redirect_uri=${returnUrl}',
                claimUrl: 'https://api.zoom.us/oauth/token',
                clientId: _.get(this.siteConfig, 'appEnvironment', 'production') == 'development' ? 'eoibLvOnQX26y2RCjeAarw' : 'gP6KIdgvS4ToijYgtX3RA'
            }
        }
    }

    getProviders() {
        return _.cloneDeep(this.providerConfig);
    }

    copyToClipboard(elem) {
        var doc = this.window.document;
        if (elem) {
            elem.select();
            doc.execCommand('copy');
        }
        return false;
    }

    getBaseUrl() {
        var getUrl = this.window.location;
        return getUrl.protocol + "//" + getUrl.host;
    }

    getReturnUrl(provider, cfg) {
        return _.get(cfg, 'returnUrl', this.getBaseUrl() + '/oauth/' + provider);
    }

    getCenteredPopupWindowFeatures(width?, height?) {

        var w = width || 800;
        var h = height || 600;

        var l = this.window.screenLeft + (this.window.outerWidth / 2) - (w / 2);
        var t = this.window.screenTop + (this.window.outerHeight / 2) - (h / 2);

        var params = {
            menubar: 'no',
            location: 'no',
            resizable: 'no',
            scrollbars: 'no',
            status: 'no',
            width: w,
            height: h,
            left: l,
            top: t
        };

        return Object.keys(params)
            .map((k) => {
                return k + '=' + params[k];
            })
            .join(',');
    }

    createPopup(provider, cfg) {
        var params = {
            returnUrl: this.getReturnUrl(provider, cfg),
            clientId: _.get(cfg, 'clientId', '')
        };

        var url = _.template(cfg.urlTemplate)(params);

        var ret = this.window.open(
            url,
            'meet_' + provider,
            this.getCenteredPopupWindowFeatures()
        );
        if (ret == null) {
            this.window.alert('Sorry, your browser blocked the meeting window from opening. Allow pop-ups for GForge Next and try again.');
        }
        return ret;
    };

    openMeetingPopup(meeting) {
        var ret = this.window.open(
            meeting.startUrl,
            'meeting_' + meeting.topic,
            this.getCenteredPopupWindowFeatures()
        );
        if (ret == null) {
            this.window.alert('Sorry, your browser blocked the meeting window from opening. Allow pop-ups for GForge Next and try again.');
        }
        return ret;
    };

    getOAuthToken(provider, cfg) {
        return new Promise((resolve, reject) => {
            this.window['handleOAuthResult'] = (code) => {
                if (typeof (code) == 'string') {
                    resolve(code);
                } else {
                    reject(code);
                }
                this.window['handleOAuthResult'] = null;
            };
            this.createPopup(provider, cfg);
        });
    };

    createMeeting(provider): Promise<any> {

        const cfg = _.get(this.providerConfig, provider, false);
        if (!cfg) {
            console.trace('Provider ' + provider + ' is not configured!');
            return Promise.reject('Provider ' + provider + ' is not configured!');
        }

        var params = {
            // No token by default
            provider: provider
        };

        return new Promise(
            (resolve, reject) =>  {

            // Does the user have an existing (server-cached) token for the specified provider?
            // If so, we'll launch the mtg with that.
            this.httpClient.post('/site/meet', params).toPromise()
            .then((response: any) => {
                var meeting = response?.data;
                if (meeting) {
                    // Add config for UI display needs
                    meeting.provider = cfg;
                    resolve(meeting);
                }else {
                    reject(response);
                }
            }, (failure) => {
                console.trace(failure);

                // If the default route didn't work,
                // initiate a new OAuth conversation via the provider
                this.getOAuthToken(provider, cfg)
                .then((token) => {

                    params['token'] = token;

                    this.httpClient.post('/site/meet', params).toPromise()
                    .then((meeting: any) => {
                        // Add config for UI display needs
                        meeting.provider = cfg;
                        resolve(meeting);

                    }, (failure) => {
                        reject(failure);
                    });

                }, (failure) => {
                    console.trace(failure);
                    this.uiService.message.showWarning('Sorry, could not authenticate to ' + cfg.title, 'Meet - ' + cfg.title);
                });
            });
        });
    };
}
